/* ============
 * Getters for the delegate module
 * ============
 *
 * The getters that are available on the
 * delegate module.
 */
import { clone } from '@/utils/object';

const getDelegates = state => clone(state.delegates);
const getTotalCount = state => clone(state.totalCount);
const getIsLoading = state => clone(state.isDelegatesLoading);

export default {
  getDelegates,
  getIsLoading,
  getTotalCount
};
